import { render } from "./OnStart.vue?vue&type=template&id=1651a8da"
import script from "./OnStart.vue?vue&type=script&lang=js"
export * from "./OnStart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\SwitchQ-Websockets\\websockets-manager-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__